import { Component, For, Show } from "solid-js";
import type { Priority } from "../../api";

export interface PriorityMeterProps {
  priority: Priority;
}

const labels: Record<Priority, string> = {
  critical: "Critical",
  high: "High",
  medium: "Medium",
  low: "Low",
  none: "None",
};
const filled: Record<Priority, number> = {
  critical: 3,
  high: 2,
  medium: 1,
  low: 0,
  none: 0,
};
const fill: Record<Priority, string> = {
  critical: "bg-signal-red",
  high: "bg-signal-amber",
  medium: "bg-ink-3",
  low: "bg-line",
  none: "bg-line",
};
const heights = ["h-1 ", "h-[7px] ", "h-2.5 "];

/** Three bars (4/7/10px) filled by level — legible without colour, announced by label. */
export const PriorityMeter: Component<PriorityMeterProps> = (props) => (
  <Show when={props.priority !== "none"}>
    <span
      role="img"
      aria-label={`Priority: ${labels[props.priority]}`}
      title={`Priority: ${labels[props.priority]}`}
      class="inline-flex items-end gap-px h-2.5 flex-shrink-0"
    >
      <For each={heights}>
        {(h, i) => (
          <span
            class={
              h +
              "w-[3px] rounded-[1px] " +
              (i() < filled[props.priority] ? fill[props.priority] : "bg-line")
            }
          />
        )}
      </For>
    </span>
  </Show>
);
